import { Route, Routes } from "react-router";
import { Navigate, useLocation } from "react-router-dom";

import routes from "./routes";

import PrivateRoute from "./routes/PrivateRoute";

import { useEffect } from "react";
import { auth } from "./firebase";
import { setUserToken } from "store/actions/Authentication";
import { useDispatch, useSelector } from "react-redux";
import Footer from "pages/Footer/Footer";

function App() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { selectedStore } = useSelector((store) => store.selectedStore);
  const isHomeRoute =
    location.pathname === `/${selectedStore?.id}` ||
    location.pathname === "/mav";

  useEffect(() => {
    const refreshUserToken = async () => {
      const user = auth.currentUser;
      if (user) {
        try {
          await user.getIdToken(true);
          dispatch(setUserToken(user.accessToken));
        } catch (error) {
          console.error("Error refreshing token:", error);
        }
      }
    };
    refreshUserToken();
    const tokenRefreshInterval = setInterval(refreshUserToken, 30 * 60 * 1000);
    return () => clearInterval(tokenRefreshInterval);
  }, [dispatch]);
  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => (
      <Route
        path={route.path}
        element={
          route.private ? (
            <PrivateRoute>{route.component}</PrivateRoute>
          ) : (
            route.component
          )
        }
        key={route.key}
      />
    ));

  return (
    <main>
      <Routes>
        <Route path="/" element={<Navigate to="/mav" />} />
        {getRoutes(routes)}
      </Routes>
      {!isHomeRoute && <Footer />}
    </main>
  );
}

export default App;
